/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.19.1-30-g35acb1d6-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CheckSshHostKeyResponseBody interface.
 */
export function instanceOfCheckSshHostKeyResponseBody(value) {
    if (!('remoteKeyType' in value) || value['remoteKeyType'] === undefined)
        return false;
    if (!('remoteKeyBase64' in value) || value['remoteKeyBase64'] === undefined)
        return false;
    return true;
}
export function CheckSshHostKeyResponseBodyFromJSON(json) {
    return CheckSshHostKeyResponseBodyFromJSONTyped(json, false);
}
export function CheckSshHostKeyResponseBodyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'remoteKeyType': json['remote_key_type'],
        'remoteKeyBase64': json['remote_key_base64'],
    };
}
export function CheckSshHostKeyResponseBodyToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'remote_key_type': value['remoteKeyType'],
        'remote_key_base64': value['remoteKeyBase64'],
    };
}
